// !!!! BEGIN scroll-based animations

gsap.registerPlugin(ScrollTrigger);

// Begin video expand animation
const videoWrapper = document.querySelector(".bg-video-wrap");
const videoElement = document.querySelector(".bg-video");

function videoExpand() {
  let expandVideo = gsap.timeline({
    defaults: { ease: Power1.easeInOut, duration: 1.5 },
    paused: true,
    scrollTrigger: {
      trigger: "#video-exp-trigger",
      // markers: true,
      start: "top 40%",
      // events: onEnter onLeave onEnterBack onLeaveBack
      toggleActions: "play none play none",
      scrub: 2
    }
  });

  expandVideo
    .to(videoWrapper, { width: "100vw" })
    // .to(videoElement, { width: "30%" }, "<")
    .to(videoWrapper, { height: "102vh" }, "<");
  // .to(videoElement, { height: "30%" }, "<");
}

ScrollTrigger.saveStyles(videoWrapper, videoElement);
ScrollTrigger.matchMedia({
  // desktop
  "(min-width: 992px)": function () {
    videoExpand();
  }
});
// !!!! end scroll-based animations
// ###############################

// ###############################
// !!!! BEGIN custom video player

// Define UI variables
const videoPlayer = document.querySelector("[data-video-wrap]");
const video = videoPlayer.querySelector("[data-video-element]");
const pauseVideoTrigger = videoPlayer.querySelector("[data-video-pause]");

const bannerVideo = document.querySelector("[data-video-banner]");
const playVideoTrigger = document.querySelector("[data-video-play-trigger]");
// const playVideoMobileTrigger = document.querySelector('.home-video__mobile-trigger');
const playVideoCursor = document.querySelector("[data-video-cursor]");
const playButtonText = playVideoCursor.querySelector("div");

// Define event listeners
// video.addEventListener("mouseover", showCursorOnMove);
video.addEventListener("ended", closeVideo);

[videoPlayer, video, pauseVideoTrigger].forEach((item) => {
  item.addEventListener("click", pauseVideo);
});

[playVideoTrigger].forEach((item) => {
  item.addEventListener("click", playVideo);
});

//   Open up video modal
playVideoTrigger.addEventListener("click", openVideoModal);
videoPlayer.addEventListener("click", openVideoModal);

// DEFINE FUNCTIONS

// Play video function
function playVideo(e) {
  if (video.paused) {
    video.play();
    setTimeout(function () {
      hideCursor(playVideoCursor);
    }, 300);
    setTimeout(function () {
      showCursor(pauseVideoTrigger);
    }, 500);
  }
}

// Play video function
function pauseVideo(e) {
  if (video.paused === false) {
    video.pause();
    showCursor(playVideoCursor);
    hideCursor(pauseVideoTrigger);
  }
}

// Hide/show play cursor functions
function hideCursor(cursor) {
  cursor.classList.add("is--hidden");
}

function showCursor(cursor) {
  cursor.classList.remove("is--hidden");
}

// Close video when ended
function closeVideo() {
  if (video.paused == false) {
    video.pause();
  }
  videoPlayer.click();
}

function openVideoModal() {
  videoPlayer.classList.toggle("is--visible");
}

// !!!! end custom video player
// ###############################

// ###############################
// !!!! BEGIN commitments hover interaction

if (window.innerWidth >= 992) {
  const commitmentItems = document.querySelectorAll(".underlined-menu-item");

  commitmentItems.forEach((item, index) => {
    function toggleActiveClass(item) {
      item.classList.toggle("active");
    }

    if (index === 0) {
      toggleActiveClass(item);
    }

    item.addEventListener("mouseenter", () => {
      document
        .querySelectorAll(".underlined-menu-item.active")
        .forEach((element) => {
          element.classList.remove("active");
        });
      item.classList.add("active");
    });
    // item.addEventListener("mouseleave", () => {
    //   toggleActiveClass(item);
    // });
  });
}

// !!!! end commitments hover interaction
// ###############################

// ################################
// Create team slider

function teamSlider() {
  let materialSplide = new Splide(".splide.team-slider", {
    // Desktop on down
    perPage: 1,
    perMove: 1,
    focus: 0, // 0 = left and 'center' = center
    type: "slide", // 'loop' or 'slide'
    gap: "4em", // space between slides
    arrows: "slider", // 'slider' or false
    drag: false,
    pagination: false, // 'slider' or false
    speed: 1300, // transition speed in miliseconds
    easing: "cubic-bezier(.645, .045, .355, 1)",
    dragAngleThreshold: 30, // default is 30
    autoWidth: true, // for cards with differing widths
    waitForTransition: false,
    updateOnMove: true,
    trimSpace: false, // true removes empty space from end of list
    flickPower: 200,
    flickMaxPages: 1,
    dragMinThreshold: 20,
    breakpoints: {
      991: {
        // Tablet
        gap: "2em", // space between slides
        drag: true
      },
      767: {
        // Mobile Landscape
        gap: "2em", // space between slides
        drag: true
      },
      479: {
        // Mobile Portrait
        gap: "2em", // space between slides
        drag: true,
        speed: 900 // transition speed in miliseconds
      }
    }
  });
  materialSplide.mount();
}
teamSlider();

// ################################
// Finish team slider

// !!!! Begin workshop slider
// ################################

var swiper = new Swiper(".swiper.workshop", {
  freeMode: {
    enabled: true,
    momentumVelocityRatio: 0.9,
    momentumBounceRatio: 0.1,
    momentumRatio: 2.1
  },
  grabCursor: true,
  observeParents: true,
  observer: true,
  keyboard: { enabled: true },
  resistanceRatio: 1,
  threshold: 1,
  watchSlidesProgress: true
});

// ################################
// !!!! End workshop slider